import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../hooks/useForm';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal } from '../common/Modal';
import { FormActions } from '../common/FormActions';
import { TextInput } from '../common/TextInput';
import { MultipleFileUploader } from '../common/MultipleFileUploader';
import { updateImageSlider } from '../../service/imageSliderService';
import { S3_BASE_URL } from '../../utils/Constants';

export default function UpdateImageSliderModal({ slider, onClose }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const { values, setField } = useForm({
    location: slider.location,
    imageUrls: slider.imageUrls || [],
  });

  const mutation = useMutation({
    mutationFn: (payload) => updateImageSlider(slider.id, payload),
    onSuccess: () => {
      qc.invalidateQueries(['imageSliders']);
      onClose();
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate({ location: values.location, imageUrls: values.imageUrls });
  };

  return (
    <Modal title={t('editImageSlider')} onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <TextInput
          label={t('location')}
          name="location"
          value={values.location}
          onChange={(e) => setField('location', e.target.value)}
          required
        />
        <MultipleFileUploader
          label={t('images')}
          onUploadComplete={(keys) => setField('imageUrls', keys)}
          previewEnabled
          t={t}
          initialKeys={values.imageUrls}
        />
        {values.imageUrls.length > 0 && (
          <div className="flex space-x-2 overflow-x-auto">
            {values.imageUrls.map((key) => (
              <img
                key={key}
                src={`${S3_BASE_URL}/${key}`}
                alt="preview"
                className="h-24 w-auto object-cover rounded"
              />
            ))}
          </div>
        )}
        <FormActions
          isLoading={mutation.isLoading}
          onCancel={onClose}
          submitLabel={t('save')}
        />
      </form>
    </Modal>
  );
}
